export default {
    meta: {
        title: '档期管理',
        isShowNav: true,
    },
};
